export enum BrandIconColor {
  BERRY = 'berry',
  PURPLE = 'purple',
  MIDNIGHT_BLUE = 'midnight-blue',
  ORANGE = 'orange',
  DARK_MINT = 'dark-mint',
  MINT = 'mint',
  WHITE = 'white',
  NONE = 'none',
  ACTION_BLUE = 'action-blue',
  AMERIPRISE_BLUE = 'ampf-blue',
  LIGHT_BLUE = 'light-blue',
  DARK_GREY = 'grey-dark',
  LIGHT_GREY = 'grey-light'
}
